import { DatePipe } from "@angular/common";
import { Column, ColumnConfig, IColumn } from "../base-column/column.model";
import { ColumnTypeEnum } from "../base-column/column-type-enum";
import { DateConfig, DateFormat } from "../../../common/date-format";
import { initFromConfig, initFromProps } from "../common-models/init-functions";

//Πρέπει να δημιουργηθεί Component το οποία θα επεκτείνει την Abstract BaseColumn και θα περιέχει τουλάχιστον τα παρακάτω.
export class DateColumn<T> extends Column<T> implements IColumn<T>{

  ConvertToLocalTimeZone: boolean = false;
  Format: string | null = null;
  ParseFormat:string = 'dd/MM/yyyy';

  constructor(config: ColumnConfig<T>);
  constructor(
    name?: string,
    propertyName?: string,
    sort?: boolean,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event?:any) => any,
    convertToLocalTimeZone?: boolean,
    parseFormat?:string,
    format?: string,
  );
  constructor(
    configOrName?: ColumnConfig<T> | string,
    propertyName?: string,
    sort?: boolean,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event?:any) => any,
    convertToLocalTimeZone?: boolean,
    parseFormat?:string,
    format?: string,
  ) {
    super();
    if (typeof configOrName === 'object') {
      const config = configOrName as ColumnConfig<T>;
      initFromConfig(this, config);
    } else {
      initFromProps(this, configOrName, propertyName, sort, tooltip, action);
      this.ConvertToLocalTimeZone = convertToLocalTimeZone ?? false;
      this.Format = format ?? null;
      this.ParseFormat = parseFormat ?? 'dd/MM/yyyy';
    }
  }

  GetAction(row: T, event?:any) {
    if (this.Action) {
      return this.Action(row, event);
    } else {
      console.log('Action is not defined in date column.');
    }
  }

  GetTooltip(): string | ((item?: any) => string) {
    return this.Tooltip ?? null;
  }

  GetSort(): boolean {
    return this.Sort ?? false;
  }
  GetPropertyName(): string {
    return this.PropertyName ?? null;
  }
  GetName(): string {
    return this.Name ?? '';
  }
  //Θα επιστρέφει το αντίστοιχο entry από το Enum για DateColumn
  GetColumnType(): ColumnTypeEnum {
    return ColumnTypeEnum.DateColumn;
  }

  //Θα πρέπει να επιστρέφει το value που θα εμφανιστεί στο grid βασισμένο στο Propertyname μετά από τους μετασχηματισμούς.
  //Για την υποστήριξη των nested object θα πρέπει να υπάρχει split και recursive αναζήτηση των properties.
  GetValue(obj?: string): string | ((item?: any) => string){
    const date = new DateConfig({
      dateStr: obj,
      parseFormat: this.ParseFormat,
    })
    return this.Action ?? DateFormat.bind(this, date) ?? '';
  }
}
